import { DomPortal } from '@angular/cdk/portal';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DriverLocationService, workOrderIdForStop } from '../../services/driver-location.service';
import { MapService } from '../../services/map.service';
import { SnackbarService } from '../../services/snackbar.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
	selector: 'app-driver-location',
	templateUrl: './driver-location.component.html',
	styleUrls: ['./driver-location.component.scss']
})
export class DriverLocationComponent implements OnInit, OnDestroy {
	public interval: any;
	public mapPortal: DomPortal<any>;
	@Input() public stop: any;
	@Input() public extraData: any;
	@Input() public showFullScreen: boolean;

	constructor(private _driverLocationService: DriverLocationService,
		private _spinnerService: SpinnerService,
		private _mapService: MapService,
		private _snackbarService: SnackbarService) {
	}

	getDriverLocation(initialLoad) {
		if (initialLoad) {
			this._spinnerService.startSpinner();
		}
		if (this.stop?.origin) {
			this._mapService.markerUpdated$.next({ address: this.stop?.origin, type: 'ORIGIN', options: { fullscreenControl: this.showFullScreen } });
		}
		if (this.stop?.destination) {
			this._mapService.markerUpdated$.next({ address: this.stop?.destination, type: 'DESTINATION', options: { fullscreenControl: this.showFullScreen } });
		}
		if (this.extraData?.address) {
			this._mapService.markerUpdated$.next({ address: this.extraData?.address, type: 'LOCATIONS', options: { fullscreenControl: this.showFullScreen, scaleControl: true, scrollwheel: true, forceDraggable: true } });
		}
		this._driverLocationService.getDriversLastLocationByWorkOrderId(workOrderIdForStop(this.stop))
			.subscribe({
				next: (location) => {
					if (location) {
						this._mapService.markerUpdated$.next({
							address: location,
							type: 'DRIVER',
							options: {
								fullscreenControl: this.showFullScreen,
								scaleControl: true,
								scrollwheel: true,
								forceDraggable: true,
								zoomControlOptions: {
									position: google.maps.ControlPosition.TOP_RIGHT,
								}
							}
						});
					} else {
						this._snackbarService.openSnackBar(`The driver's location is currently unavailable`, 'Close', 3000, 'info')
					}
					this._spinnerService.stopSpinner();
				}, error: (error) => {
					this._snackbarService.openSnackBar(`The driver's location is unavailable`, 'Close', null, 'alert');
					this._spinnerService.stopSpinner();
				}
			});
	}

	ngOnDestroy() {
		if (this.interval) {
			clearInterval(this.interval);
		}
		// Clear out any markers
		this._mapService.markerUpdated$.next({ address: null, type: 'ORIGIN' });
		this._mapService.markerUpdated$.next({ address: null, type: 'DESTINATION' });
		this._mapService.markerUpdated$.next({ address: null, type: 'DRIVER' });
	}

	ngOnInit() {
		this.mapPortal = new DomPortal(document?.getElementById('mapPortalContent'));
		this.getDriverLocation(true);
		this.startInterval();
	}

	startInterval() {
		this.interval = setInterval(() => {
			this.getDriverLocation(false);
		}, 60000);
	}
}
